<template>
  <v-expansion-panel-content>
    <ConfirmationDialog
      @confirmed="save"
      :onSetConfirmedDialog="setConfirmedDialog"
      :confirmedDialog="$store.state.hab.confirmedDialog"
      :title="title"
      :content="content"
    />
    <v-item-group multiple>
      <v-container fluid class="pa-0">
        <v-row>
          <!-- LIST OF ADL -->
          <v-col
            cols="12"
            md="4"
            v-for="(hab, index) in habData.filter(
                (item) => item.isSigned != true
              )"
            :key="index"
            :class="defaultMargin"
          >
            <v-item>
              <v-card
                x-width="100%"
                min-height="100%"
                id="HABCard"
              >
                <v-toolbar dark color="primary" dense>
                  <v-toolbar-title>
                    <v-card-title class="body-2">
                      {{ hab.step }}
                      <!-- NOTHING TO PUT HERE -->
                    </v-card-title>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>

                <v-container
                    class="fill-height ma-0 pa-0 img-container"
                    fluid
                >
                  <div class="overlay-fade  ma-0 pa-0">
                    <v-chip
                        class="ma-2 schedule-time darken-4"
                        color="blue"
                        label
                        text-color="white"
                    >
                      <v-icon left>
                        mdi-clock
                      </v-icon>
                    </v-chip>
                    <span class="shared-link">
                      <v-icon
                        @click="createShareLink(hab)"
                        class="mr-3 my-n5 "
                        color="white"
                      >
                        mdi-share-variant
                      </v-icon>
                    </span>
                    <div></div>
                  </div>
                  <p class="description ma-2 pa-2 text-body2">
                        <span v-if="hab.reveal">{{
                            hab.step.substring(0, 3)
                          }}</span>
                    <span
                        v-if="hab.step.length >= 3"
                        @click="readMore(index, hab)"
                    >
                          <a
                              color="#BBDEFB"
                              class="caption"
                              v-if="hab.reveal"
                          >...Read More
                          </a>
                        </span>

                    <v-expand-transition>
                      <v-card
                          v-if="reveal && cardIndex === index"
                          class="transition-fast-in-fast-out v-card--reveal"
                          style="height: 500;"
                      >
                        <v-card-text class="pb-0">
                          <p>{{ hab.step }}</p>
                        </v-card-text>
                        <v-card-actions>
                          <v-list-item class="grow">
                            <v-row justify="end">
                              <v-btn
                                  text
                                  color="primary accent-4"
                                  @click="onReveal(hab)"
                              >
                                Close
                              </v-btn>
                            </v-row>
                          </v-list-item>
                        </v-card-actions>
                      </v-card>
                    </v-expand-transition>
                  </p>
                </v-container>

                <v-row dense class="ma-3">
                  <v-col cols="12" sm="12">
                    <v-select
                        label="Select One"
                        v-model="hab.newAssistance"
                        outlined
                        height="10"
                        :items="tableKey"
                        clearable
                        hide-details
                        @change="checkAssistance(hab)"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row dense class="ma-3" v-if="hab.showPromptValue">
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field
                      v-model="hab.newPromptValue"
                      outlined
                      clear-icon="mdi-close-circle"
                      clearable
                      label="Prompt"
                      type="number"
                    >
                      <template v-slot:prepend>
                        <v-btn
                          color="red"
                          fab
                          x-small
                          dark
                          @click="decrementPrompt(hab)"
                        >
                          <v-icon>mdi-minus</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:append-outer>
                        <v-btn
                          color="green"
                          fab
                          x-small
                          dark
                          @click="incrementPrompt(hab)"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row class="ma-3">
                  <v-col cols="12" sm="12" class="pa-1">
                    <v-textarea
                        label="Add Notes"
                        v-model="hab.newNotes"
                        outlined
                        auto-grow
                        hide-details
                        rows="2"
                        row-height="20"
                    >
                    </v-textarea>
                  </v-col>
                </v-row>

                <v-row class="ma-3">
                  <v-col cols="12" md="12" class="mt-n8 ">
                    <v-checkbox
                        label="Signature"
                        hide-details
                        @change="addSignature(hab)"
                        v-model="hab.signed"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="12" class="mt-n8 ">
                    <v-text-field
                        v-model="hab.newSignature"
                        :error-messages="hab.error"
                        readonly
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-card-actions>
                  <v-btn
                    class="mb-3 mt-n4"
                    block
                      color="primary"
                    :loading="$store.state.hab.isLoading"
                    :disabled="multipleSelectedItem ? multipleSelectedItem : isDisable"
                    @click="onAddHABSigned(hab)"
                  >
                    submit
                    <template v-slot:loader>
                      <span>Loading...</span>
                    </template>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>
  </v-expansion-panel-content>
</template>

<script>

import {mapActions, mapMutations} from "vuex";
import moment from "moment";
import ConfirmationDialog from "@/components/shared/ConfirmationDialog";
export default {
    props: {
      habData: {
        type: Array,
      },
      userDateToday:{
      }
    },
    components: {
      ConfirmationDialog
    },
    data() {
      return {
        tableKey: ["Prompts Needed", "Participated", "Refused", "Home Visit", "Absent", "Yes", "No"],
        newTableKey: "",
        newNotes: "",
        newException: "",
        newAssistance: "",
        newSignature: "",
        multipleSelectedItem: false,
        signed: false,
        selectedIndex: [],
        selectedMAR: [],
        error: null,
        generatedURL: "",
        reveal: false,
        cardIndex: null,
        staff: localStorage.getItem("Name"),
        title: "Confirming...",
        content: "Do you confirm the completion of the HAB?",
        itemData: "",
        clientID : "",
      };
    }, 

    computed: {
        defaultMargin() {
            return this.$vuetify.breakpoint.xsOnly ? "pa-0 my-3" : "pa-3";
        },
        
      isDisable: {
        get() {
          return this.$store.state.hab.isDisableButton;
        },
        set(val) {
          this.$store.commit("hab/SET_DISABLE_BUTTON", val);
        },
      },
    },

    created() {
      this.clientID = this.$route.params.clientID;
    },

    methods: {
      ...mapActions({
        addHABSigned: "hab/addHABSigned",
      }),

      ...mapMutations({
        setConfirmedDialog: "hab/SET_CONFIRMED_DIALOG",
      }),

      addSignature(hab) {
        if (hab.signed) {
            hab.newSignature = this.staff + " - " + new Date();
            hab.error = "";
        } else {
            hab.newSignature = "";
            hab.error = "";
        }
      },

      readMore(index, item) {
        item.reveal = false;
        this.cardIndex = index;
        this.reveal = true;
      },

      onReveal(item) {
        item.reveal = true;
        this.reveal = false;
      },

      onAddHABSigned(hab){
        console.log(hab)
        if (hab.newSignature === "") {
          return (hab.error = "Signature is required", this.isDisable = false);
        }
        this.setConfirmedDialog(true);
        this.itemData = hab;
      },

      async save(){
        this.setConfirmedDialog(false);
        this.isDisable = true;
        let hab = this.itemData;

        var req_body = {
          HABPlan: hab._id,
          Date: moment().toDate(),
          Assistance: hab.newAssistance,
          Prompt: hab.newPromptValue,
          Notes: hab.newNotes,
          Signature: hab.newSignature,
          ClientID: this.clientID,
          Step: hab.stepId,
          StepDescription: hab.step,
          customDate: this.userDateToday,
        };
        await this.addHABSigned(req_body);
        this.$emit("getHAB"); // reload Page
      },

      checkAssistance(hab){
        hab.newPromptValue = 0;
        if(hab.newAssistance == "Prompts Needed"){
          hab.showPromptValue = true;
        }else{
          hab.showPromptValue = false;
        }

      },

      incrementPrompt(hab){
        hab.newPromptValue++;
      },

      decrementPrompt(hab){
        if(hab.newPromptValue > 0){
           hab.newPromptValue--;
        }
      }

    }
}
</script>

<style scoped>
.v-expansion-panel--active
> .v-expansion-panel-header--active
.v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate)
.v-icon {
  transform: none !important;
}

.panel-header {
  min-height: 100px;
}

.fab-multiple {
  z-index: 999;
}

.adl-image {
  width: 100%;
  height: 250px;
  background-size: contain;
}

.overlay-fade {
  position: relative;
  box-sizing: border-box;
  height: 250px;
  width: 100%;
  overflow: hidden;
  float: left;
  margin: 10px;
}

.overlay-fade div {
  position: absolute;
  box-sizing: border-box;
  top: 0;
  background: rgb(0, 3, 28);
  background: linear-gradient(
      0deg,
      rgba(0, 3, 28, 1) 37%,
      rgba(133, 134, 146, 1) 54%,
      rgba(255, 255, 255, 1) 100%
  );
  width: 100%;
  height: 250px;
  opacity: 0.5;
  transition: all 0.2s ease-in;
}

.schedule-time {
  position: absolute;
  right: 0;
  margin-right: 10px;
  margin-top: 10px;
  z-index: 2;
}

.btn-image-upload {
  position: absolute;
  right: 0;
  margin-right: 9px;
  margin-top: 45px;
  z-index: 2;
}

.btn-follow-up {
  position: absolute;
  width: 55%;
  right: 0;
  margin-right: 9px;
  margin-top: 120px;
  z-index: 2;
  padding-top: 40px;
}

.btn-incident-report {
  position: absolute;
  width: 55%;
  right: 0;
  margin-right: 9px;
  margin-top: 180px;
  z-index: 2;
}

.btn-view-image {
  position: absolute;
  width: 50%;
  right: 0;
  margin-right: 9px;
  margin-top: 80px;
  z-index: 2;
}

.shared-link {
  position: absolute;
  right: 0;
  bottom: 0;
  margin-bottom: 10px;
  z-index: 2;
}

.img-container {
  position: relative;
}

.description {
  bottom: -10px;
  position: absolute;
  color: white;
}
</style>
